import Vue from "vue";
import Vuex from "vuex";
import common from "./common";
Vue.use(Vuex);

//创建VueX对象

export default new Vuex.Store({
  ...common,
});
